// community-portal
export const host = "https://portal.purpledoorfinders.com/";

// prospect
export const prospectHost = "https://purpledoorfinders.com/";
